import React, { useCallback, useEffect, useState } from 'react';
import { Outlet } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import SummaryApi from './common';
import Context from './context';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './store/userSlice';
import ScrollToTop from "./components/ScrollToTop";

const App = () => {

  const dispatch = useDispatch();
  const [cartProductCount, setCartProductCount] = useState(0);

  // ------------------ GET USER ------------------
  const fetchUserDetails = useCallback(async () => {
    try {
      const res = await fetch(SummaryApi.current_user.url, {
        method: SummaryApi.current_user.method,
        credentials: "include"
      });

      const data = await res.json();

      if (res.status === 200 && data?.success) {
        dispatch(setUserDetails(data.data));
      } else {
        dispatch(setUserDetails(null));
      }

    } catch {
      dispatch(setUserDetails(null));
    }
  }, [dispatch]);

  // ------------------ GET CART COUNT ------------------
  const fetchUserAddToCart = useCallback(async () => {
    try {
      const res = await fetch(SummaryApi.addToCartProductCount.url, {
        method: SummaryApi.addToCartProductCount.method,
        credentials: "include"
      });

      const data = await res.json();

      setCartProductCount(
        data?.data?.count ??
        data?.totalCount ??
        0
      );

    } catch {
      setCartProductCount(0);
    }
  }, []);

  // ------------------ ON LOAD ------------------
  useEffect(() => {
    fetchUserDetails();
    fetchUserAddToCart();
  }, [fetchUserDetails, fetchUserAddToCart]);

  return (
    <Context.Provider value={{
      fetchUserDetails,
      fetchUserAddToCart,
      cartProductCount
    }}>
      <ToastContainer position="top-center" />
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow pt-16">
          <Outlet />
        </main>
        <Footer />
      </div>
    </Context.Provider>
  );
};

export default App;
